<template>
    <div id="messNote" @click="closeClick($event)" v-show="versionNote !== false">
        <div id="cardMessageNote" no-body class="text-center card card-container bg-white color-dark" >
            <div class="card-title">
               Release Note <b>{{this.$version}}</b> Onico EMR
           </div>

            <div class="card-body"> 
                <div class="note card-text" v-html="versionNote">
                </div>
            </div>

            <div style="text-align: center;z-index:2000">
                <button class="col-12 col-lg-4 bg-danger text-white rounded" href="#" @click="closedSubMod(true)">
                    {{closeBtnTxt}}
                </button>
            </div>   
        </div>
    </div>
</template>
<script>
export default {
    name:"noteModal",
    emits:['goBack'],
    data(){
        return{
            versionNote:(localStorage.versionNote) ? localStorage.versionNote : false,
            closeBtnTxt:"Cerrar",
        }
    },
    beforeUnmount(){
        window.removeEventListener('keydown', this.keyDownHandler)
    },
    mounted() {
        window.addEventListener('keydown', this.keyDownHandler)
    },
    methods:{
        closeClick(e){
            if(e.target.id == "messNote"){
                e.stopImmediatePropagation();
                document.getElementById('cardMessageNote').classList.add('closing');
                setTimeout(()=>{
                    this.$emit('goBack');
                }, 300)
            }
        },
        keyDownHandler(e) {
            if(e.key === 'Escape'){
                document.getElementById('cardMessageNote').classList.add('closing');
                setTimeout(()=>{
                   this.$emit('goBack');
                }, 300)
            }
        },
        closedSubMod(cover=false){
            document.getElementById('cardMessageNote').classList.add('closing');
            setTimeout(()=>{
                this.$emit('goBack'); 
            }, 300)
        },
    }
}
</script>
<style lang="css">
    #messNote{
        position: fixed;
        width: 100vw;
        height: 100vh;
        background-color: transparent;
        z-index: 1201;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        background-color: rgba(0, 0, 0, 0.5);
    }
    #messNote .card{
        padding: 20px;
        width: 720px;
        margin: auto;
        height: auto;
        max-height: 80%;
        overflow-y:auto;
        animation: show 0.4s ease 1;
    }

    #messNote .card-body{
        scrollbar-width: none !important;
        overflow-y: auto !important;
        color: transparent;
        margin-bottom: 10px;
    }

    #messNote .card-body > *{
        color: #343a40
    }

    #messNote .card-text{
        text-align: left;
        overflow: hidden;
    }

    #messNote .card-body::-webkit-scrollbar{
        background-color: transparent;
        width: 8px;
    }
    
    #messNote .card-body::-webkit-scrollbar-thumb{
        background-clip: padding-box;
        box-shadow: inset 0 0 0 10px;
        border-radius: 3px;
    }
    
    #messNote .card-body:hover{
        color: rgba(241, 87, 83, 0.6);
    }
    

    #messNote new::before{
        content:"Nuevo";
        display: inline-flex;
        align-items: center;
        align-content: center;
        text-align: center;
        justify-content: center;
        width: 80px;
        height: auto;
        margin-bottom: 6px;
        padding: 2px 7px 2px 7px;
        margin-left: 20px;
        border-radius: 0.4rem;
        position: relative;
        font-size: 15px;
        font-weight: bold;
        color:#fff;
        background-color: var(--primary);
    }
    #messNote fix::before{
        content:"Arreglos";
        display: inline-flex;
        align-items: center;
        align-content: center;
        text-align: center;
        justify-content: center;
        width: 80px;
        height: auto;
        margin-bottom: 6px;
        padding: 2px 7px 2px 7px;
        margin-left: 20px;
        border-radius: 0.4rem;
        position: relative;
        font-size: 15px;
        font-weight: bold;
        color:#fff;
        background-color: var(--secondary);
    }

    #messNote ul{
        list-style-type:square
    }

    #cardMessageNote.closing{
        animation: hide 0.3s ease 1 forwards;
    }

    @keyframes show {
        0%{
            opacity: 0.8;
            transform: perspective(900px)
                            rotateX(90deg);
        }
            40%{
            opacity: 1;
            transform: perspective(900px)
                            rotateX(-5deg);
        }
    }
    @keyframes hide {
        60%{
            opacity: 1;
            transform: perspective(900px)
                            rotateX(-5deg);
        }
        100%{
            opacity: 0.8;
            transform: perspective(900px)
                            rotateX(90deg);
        }
    }
</style>